import useTranslationText from 'Hooks/useTranslationText'
import { NavLink } from 'react-router-dom'
import React from 'react'

const CancelButton = (props: any) => {
    const [translation] = useTranslationText()
    return (
        <React.Fragment>
            <NavLink
                type='button'
                to={props.link}
                className="btn btn-danger mb-1 mb-lg-0 me-1 text-light">
                {translation('BACK')}
            </NavLink>
        </React.Fragment>
    )
}

export default CancelButton